import PartPopup from './PartPopup';
export default PartPopup;